<ng-container>
  <div class="container">
    @if (label) {
      <label [for]="identifier">{{ label }}</label>
    }
    <select name="application-type-selector" [(ngModel)]="value" [id]="identifier" [compareWith]="equals" [disabled]="disabled">
      <option [ngValue]="null" selected>{{ placeholder }}</option>
      @for (option of optionList; track option) {
        <option [ngValue]="option?.value">{{ option?.displayText }}</option>
      }
    </select>
  </div>
</ng-container>